// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Typography } from '@mui/material';
import FormDialog from '../../../components/Dialog/FormDialog';

interface CreateAllocationConfirmationProps {
  open: boolean;
  onClose: () => void;
  onWithdraw: (() => Promise<unknown>) | undefined;
}

export const WithdrawAllocationConfirmationDialog: React.FC<CreateAllocationConfirmationProps> = ({
  open,
  onClose,
  onWithdraw,
}) => {
  const handleSubmit = React.useCallback(() => {
    if (onWithdraw) {
      return onWithdraw().finally(() => {
        onClose();
      });
    }
    onClose();
    return Promise.resolve();
  }, [onClose, onWithdraw]);
  return (
    <FormDialog
      open={open}
      title="Withdraw Allocation"
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitName="Withdraw"
    >
      <Box>
        <Typography sx={{ mt: 2 }} variant="body2">
          Would you like to continue?
        </Typography>
      </Box>
    </FormDialog>
  );
};
